import React, { useState } from "react";
import styled from "@emotion/styled";

import { Text } from "@components/core/Text";

import { compassColors } from "@utils/styling";
import { fontP3Regular } from "src/design-system/styles/fonts";
import { MedicareAttestationModal } from "./MedicareAttestationModal";

const ConsentLink = styled.a`
  ${fontP3Regular}
  color: ${compassColors.denim};
  text-decoration: underline;
  cursor: pointer;
`;

export function MedicareAttestationCheckboxLabel() {
  const [showModal, setShowModal] = useState(false);

  const handleLinkClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  return (
    <>
      <Text
        i18nKey="payment:terms:medicareAttestationConsent"
        components={{
          ConsentLink: (
            <ConsentLink
              href="#"
              onClick={handleLinkClick}
              data-cy="medicare-attestation-link"
            />
          ),
        }}
      />
      {showModal && <MedicareAttestationModal onClose={handleCloseModal} />}
    </>
  );
}
